import React from "react";
import {
  CompletedChip,
  TeamsChip,
  MandatoryChip,
  RequestedChip,
  SurveyChip,
  AttestChip,
  LockedChip,
} from "Components/Module/LearningActivityItem/Chips";

// Create a base component for common chip logic
const BaseChips = ({
  course,
  completed,
  languageContext,
  isPortalOverview,
}) => (
  <>
    {/* Teams + Mandatory combination */}
    {course.mandatory && !completed && course.microsoftTeamId && (
      <>
        <TeamsChip label={languageContext("connectedToTeams")} />
        <MandatoryChip label={languageContext("mandatory")} />
      </>
    )}
    {/* Mandatory only */}
    {course.mandatory && !completed && !course.microsoftTeamId && (
      <MandatoryChip label={languageContext("mandatory")} />
    )}
    {/* Teams only */}
    {!course.mandatory && !completed && course.microsoftTeamId && (
      <TeamsChip label={languageContext("connectedToTeams")} />
    )}
    {/* Completed status */}
    {completed && <CompletedChip label={languageContext("completed")} />}
    {/* Requested status */}
    {course.requested && (
      <RequestedChip label={languageContext("courserequested")} />
    )}
    {/* Locked status */}
    {!isPortalOverview && !course.isActiveStep && (
      <LockedChip label={languageContext("locked")} />
    )}
    {/* Locked until registration status */}
    {course.numberOfDaysUntilRegistration > 0 && (
      <LockedChip
        label={`${languageContext("unlocksin")} ${course.numberOfDaysUntilRegistration} ${languageContext("days").toLowerCase()}`}
      />
    )}
  </>
);

export const SurveyProgramChips = ({ course, completed, languageContext }) => (
  <>
    <BaseChips
      course={course}
      completed={completed}
      languageContext={languageContext}
    />
    {course.mandatorySurveySent && !course.completed && (
      <SurveyChip label={languageContext("surveyHasBeenSent")} />
    )}
  </>
);

export const ActivityProgramChips = (props) => <BaseChips {...props} />;

export const ClassroomProgramChips = ({ course, ...props }) => (
  <>
    <BaseChips course={course} {...props} />
    {!props.isPortalOverview &&
      !course.completed &&
      course.attestStatus === "ATTEST_WAITING" && (
        <AttestChip label={props.languageContext("waitingforattest")} />
      )}
  </>
);

export const OnlineProgramChips = (props) => <BaseChips {...props} />;

export const ProgramChips = (props) => <BaseChips {...props} />;
